<pg-header
  title="Roles And Permissions"
  ticon="idcard"
  bckbtn="true"
  bckurl="/setup"
></pg-header>

@if (usrAcsErrMsg == false) {
<div>
  <div class="ds-card grid">
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="roledta"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
      exportFileName="LMO Details"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="openSideBar('edit', data)">Edit</div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
        [width]="100"
        caption="Edit Permissions"
        cellTemplate="editPrmTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editPrmTemplate" let-data="cell"
        ><div>
          <div
            class="tblDelBtn"
            (click)="openSideBar('Edit Permissions', data)"
          >
            Edit Permissions
          </div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
        [width]="100"
        caption="Delete"
        cellTemplate="deleteTemplate"
      ></app-grid-column>
      <ng-template appGridCell="deleteTemplate" let-data="cell"
        ><div>
          <div class="tblDelBtn" (click)="delete(data)">Delete</div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
  @if (loader) {
  <ds-loading></ds-loading>
  }
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="550"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    @if (!permismdl) {
    <div fxLayout="column" fxLayoutAlign="space-between center">
      <form nz-form [formGroup]="RolesForm" style="width: 100%" class="mt-12">
        <div fxLayout="column" fxLayoutAlign="start start">
          <div class="form-label">Enter Role Name</div>
          <nz-form-item class="ant-form-item">
            <nz-form-control style="width: 100%">
              <input
                type="text"
                autocomplete="off"
                nz-input
                formControlName="rle_nm"
                placeholder="Rolename"
              />
              @for (validation of account_validation_messages.rolename; track
              validation) {
              <div style="margin-top: 1.5%; color: red">
                @if (RolesForm.get('rle_nm').hasError(validation.type) &&
                (RolesForm.get('rle_nm').dirty ||
                RolesForm.get('rle_nm').touched)) {
                {{ validation.message }}
                }
              </div>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        <div fxLayout="column" fxLayoutAlign="start start">
          <div class="form-label">Enter Role Description</div>
          <nz-form-item class="ant-form-item">
            <textarea
              nz-input
              placeholder="Role Description"
              formControlName="rle_dscn_nm"
            ></textarea>
          </nz-form-item>
        </div>
      </form>
      <div class="row" fxLayoutAlign="end center">
        <div class="col-6" style="text-align: right">
          <button
            nz-button
            nzType="primary"
            [disabled]="RolesForm.invalid"
            class="m-r-10"
            (click)="saveRole()"
          >
            Save
          </button>
        </div>
        <div class="col-6">
          <button
            nz-button
            nzType="primary"
            class="m-r-10"
            (click)="closeSideBar()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    } @if (permismdl) {
    <div
      class="font-size-17 font-weight-500 pt-8 mb-0 pl-8 pb-8 red-800-fg"
      style="color: #a52907; font-weight: 500; margin: auto"
    >
      Standard Permissions
    </div>
    <table style="width: 100%; margin-top: 3%">
      <tr
        style="
          font-weight: 500;
          text-transform: capitalize;
          letter-spacing: 0.7px;
        "
      >
        <th></th>
        <th>Read</th>
        <th>Write</th>
        <th>Update</th>
        <th>Delete</th>
        <th>Export</th>
      </tr>
      @for (obj of rlepermdta; track obj) {
      <tr
        style="
          font-weight: 500;
          text-transform: capitalize;
          letter-spacing: 0.7px;
        "
      >
        <td>
          <p class="pmdlcs">{{ obj.objct_nm }}</p>
        </td>
        <td><label nz-checkbox [(ngModel)]="obj.slct_in"></label></td>
        <td><label nz-checkbox [(ngModel)]="obj.insrt_in"></label></td>
        <td><label nz-checkbox [(ngModel)]="obj.updt_in"></label></td>
        <td><label nz-checkbox [(ngModel)]="obj.dlte_in"></label></td>
        <td><label nz-checkbox [(ngModel)]="obj.exprt_in"></label></td>
      </tr>
      }
    </table>
    <div
      class="m-0 p-20"
      fxLayout="row"
      style="text-align: right"
      fxLayoutAlign="end center"
    >
      <button
        nz-button
        nzType="primary"
        (click)="createPermson()"
        class="m-r-10"
      >
        Save
      </button>
    </div>
    }
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
  </nz-result>
</div>
}
